import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const opts = {
  theme: {
    themes: {
      light: {
        primary: "#445c7c",
        secondary: "#1b365d",
        danger: "#de5766",
        warning: "#E65100",
        success: "#5cb85c",
        error: "#EB0000",
        info: "#0B78D0"
      }
    }
  }
};

export default new Vuetify(opts);
